export default function BtnLoader(props) {
  return (
    <div className="loadingio-spinner-spinner-68ljkn45nie"><div className="ldio-a6scf62lqlj"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
  )
}